module.exports = __webpack_public_path__ + "img/speciment01.516e3feb.png";